(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hof-loop-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-loop-video')) {
    // Plays a card loop only while the card is on screen; loads nothing until then.
    // Skipped for reduced-motion and data-saver users, who keep the photo.
    // Spacing rule: a card does not start moving while a card beside it, or directly above or
    // below it, is moving (diagonal is fine). It shows its photo and starts once that neighbour
    // scrolls away. This keeps any grid (gifting, search, new arrivals) from clustering.
    const calm =
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      (navigator.connection && navigator.connection.saveData);
    const pickSource = (video) => {
      const { hls, src } = video.dataset;
      return hls && video.canPlayType('application/vnd.apple.mpegurl') ? hls : src;
    };

    const playing = new Set();
    const waiting = new Set();

    const overlap = (a1, a2, b1, b2) => Math.max(0, Math.min(a2, b2) - Math.max(a1, b1));
    const isNeighbour = (a, b) => {
      const r = a.getBoundingClientRect();
      const s = b.getBoundingClientRect();
      const sameRow = overlap(r.top, r.bottom, s.top, s.bottom) > Math.min(r.height, s.height) / 2;
      const sameColumn = overlap(r.left, r.right, s.left, s.right) > Math.min(r.width, s.width) / 2;
      const stacked = sameColumn && Math.abs(r.top - s.top) < Math.max(r.height, s.height) * 1.6;
      return sameRow || stacked;
    };

    const start = (el) => {
      for (const other of playing) if (isNeighbour(el, other)) return false;
      const video = el.querySelector('video');
      if (!video.src) video.src = pickSource(video);
      video.play().catch(() => {});
      playing.add(el);
      waiting.delete(el);
      return true;
    };

    const stop = (el) => {
      el.querySelector('video').pause();
      const wasPlaying = playing.delete(el);
      waiting.delete(el);
      if (wasPlaying) for (const next of [...waiting]) start(next);
    };

    const observer = calm
      ? null
      : new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                if (!playing.has(entry.target) && !start(entry.target)) waiting.add(entry.target);
              } else {
                stop(entry.target);
              }
            }
          },
          { threshold: 0.4 }
        );

    customElements.define(
      'card-loop-video',
      class extends HTMLElement {
        connectedCallback() {
          if (!observer) return;
          const video = this.querySelector('video');
          video.addEventListener('playing', () => this.classList.add('is-playing'));
          video.addEventListener('pause', () => this.classList.remove('is-playing'));
          observer.observe(this);
        }
        disconnectedCallback() {
          if (!observer) return;
          observer.unobserve(this);
          stop(this);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
